import { render } from "./ScheduleSession.vue?vue&type=template&id=5c85bfeb"
import script from "./ScheduleSession.vue?vue&type=script&lang=js"
export * from "./ScheduleSession.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__